export const TOKEN_TIME = 'tokenTime'
// token
export const TOKEN = 'token'
// 2 * 60 * 60 * 1000
export const TOKEN_TIME_VALUE = 2 * 60 * 60 * 1000

export const LOGIN_TYPE = 'loginType' // 0本系统登录逻辑 1用户系统单点登录逻辑
